export const ORGANIZATION_FORM_KEYS = {
  NAME: 'name',
  COUNTRY: 'country',
  STREET: 'street',
  PROVINCE: 'province',
  POSTAL: 'postal',
  OWNER_EMAIL: 'ownerEmail',
  LOGO: 'logo',
} as const;

export const ORGANIZATION_FORM_VALIDATION = {
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 200,
  STREET_MIN_LENGTH: 3,
  PROVINCE_MIN_LENGTH: 2,
  POSTAL_MIN_LENGTH: 3,
  POSTAL_MAX_LENGTH: 20,
  LOGO_MAX_SIZE_MB: 5,
} as const;
